
export namespace Config {
	export const defaultLang = 'en';

	//let root = 'https://localhost:7073';
	//let root = 'http://weframe.vorbion.com:8124';
	//let root = 'https://weframe.vorbion.com';
	//export const apiRoot = root + '/';

	export const eventLangChanged = 'langChanged';
}
